import { HUBSPOT_HOW_TO } from '../../constants/CopilotInAppActionTypes';
export const hubspotHowTo = action => {
  return {
    data: {
      intent: HUBSPOT_HOW_TO,
      query: action.query
    }
  };
};